var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialSymbolsContactPageRounded({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C11.12157861 -0.61107575 11.12157861 -0.61107575 14.875 2 C17.67811244 5.95733521 17.58331168 8.61379752 17.3125 13.3125 C17.209375 15.849375 17.10625 18.38625 17 21 C11.39 21 5.78 21 0 21 C0 14.07 0 7.14 0 0 Z M7 9 C7 9.99 7 10.98 7 12 C7.99 12 8.98 12 10 12 C10 11.01 10 10.02 10 9 C9.01 9 8.02 9 7 9 Z M6 14 C5.67 14.66 5.34 15.32 5 16 C7.31 16 9.62 16 12 16 C11.67 15.34 11.34 14.68 11 14 C9.35 14 7.7 14 6 14 Z ",
    fill: "#FFFFFF",
    transform: "translate(4,2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsContactPageRounded);
export default __webpack_public_path__ + "static/media/material-symbols_contact-page-rounded.4eacabceb43a8d7b25dea1f2d3f21bb1.svg";
export { ForwardRef as ReactComponent };